import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BOOK_DEMO_URL, EASE } from "../../lib/motion";

const ClosingCTA = () => {
  return (
    <section
      data-testid="closing-cta-section"
      className="relative bg-[#1C1C1E] py-28 md:py-40 overflow-hidden"
    >
      {/* thin gold gridlines motif on dark */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #B39B77 1px, transparent 1px), linear-gradient(to bottom, #B39B77 1px, transparent 1px)",
          backgroundSize: "72px 72px",
        }}
      />
      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: EASE }}
          className="font-body text-xs uppercase tracking-[0.28em] text-[#B39B77]/70 mb-8"
        >
          The simplest way to say it
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
          className="font-display font-semibold text-[#B39B77] text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl mx-auto"
          data-testid="closing-cta-headline"
        >
          It&apos;s like Googling
          <br className="hidden sm:block" /> your own business.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.25 }}
          className="mt-12"
        >
          <a
            href={BOOK_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="closing-book-demo"
            className="group inline-flex items-center gap-2 rounded-full bg-[#B39B77] px-8 py-4 font-body text-base font-medium text-[#1C1C1E] transition-colors duration-300 hover:bg-[#96805E]"
          >
            Book a Demo
            <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ClosingCTA;
